/**
 * Pill-style clickable link for a submission's external item URL: displays just
 * the domain (via extractDomain, falling back to the raw URL) and opens the
 * full link in a new tab on click. Used on the submission detail page
 * (SubmissionDisplay).
 */
import { extractDomain } from "@/utils/url";
interface ItemLinkProps {
    itemLink: string;
    className?: string;
}

const ItemLink: React.FC<ItemLinkProps> = ({ itemLink, className }) => {
    const onClick = () => {
        try {
            window.open(itemLink, "_blank");
        } catch (error) {
            console.error("Error opening item link:", error);
        }
    };

    let displayDomain: string;
    try {
        displayDomain = extractDomain(itemLink);
    } catch {
        displayDomain = itemLink;
    }

    return (
        <div
            className={`flex w-full shadow-[0_0_8px_rgba(0,0,0,0.1)] text-lg h-10 py-2 px-2 justify-center items-center font-porsui text-black bg-slate-50 rounded-xl cursor-pointer hover:shadow-[0_0_12px_rgba(0,0,0,0.15)] transition-shadow ${className}`}
            onClick={onClick}
        >
            {displayDomain}
        </div>
    );
};

export default ItemLink;
